import { useEffect, useRef, useContext } from 'react'
import { UserContext } from '../context'

const useLogEvent = (eventObjectOrName, ready = true) => {
  const { logEvent } = useContext(UserContext)
  const hasLoggedRef = useRef(false)

  useEffect(() => {
    if (!ready) return
    if (hasLoggedRef.current) return

    logEvent(eventObjectOrName)
      .then(() => { hasLoggedRef.current = true })
      .catch(console.error)
  }, [eventObjectOrName, ready, logEvent])
}

export {
  useLogEvent,
}
